const getSdkHelpers = (): {
  getSDK: () => any
  setSDK: (sdk: any) => void
} => {
  let sdk: any
  const getSDK = (): any => {
    return sdk
  }
  const setSDK = (loadedSdk: any): void => {
    sdk = loadedSdk
  }
  return {
    getSDK,
    setSDK
  }
}

const SdkHelpers = getSdkHelpers()

export default SdkHelpers